"use strict";
// waboba2.myshopify.com
(function () {
  const url = new URL(window.location.href);

  if (url.pathname.includes("international-shipping")) return;

  const EU_COUNTRIE_CODES = [
    "AT",
    "BE",
    "BG",
    "HR",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    // "NO",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    // "CH",
  ];
  // We do not ship to NO and CH is at the moment. This list might change later.

  const isLocalEnv = url.hostname == "127.0.0.1";
  const apiEndpoint = isLocalEnv
    ? "https://server.localwaboba.com:8000/api/country/"
    : "https://x-country.waboba.com";

  function showShipUSOnlyInfo() {
    const newDiv = document.createElement("div");
    newDiv.setAttribute("id", "waboba-region-no-shipping");
    newDiv.innerHTML = `
                <div class="waboba-region-no-shipping__container">
                    <div class="waboba-region-no-shipping__overlay"></div>
                    <div class="waboba-region-no-shipping__box">
                        <div class='waboba-region-no-shipping__x-button'>&times;</div>
                        <h2>HEADS UP!</h2>
                        <div style="margin-top:2rem;">This store only ships to the United States and EU.</div>
                        <div>For international shipping please visit our store on Amazon here.</div>
                        <div style="margin-top: 2rem;">
                          <a id="waboba-region-no-shipping__ok-button" class="btn btn--secondary" href="/pages/international-shipping">LEARN MORE</a>
                        </div>
                    </div>
                </div>
            `;
    document.body.appendChild(newDiv);
    setTimeout(() => {
      newDiv.classList.add("show");
    }, 500);
    document
      .querySelectorAll(
        ".waboba-region-no-shipping__overlay, .waboba-region-no-shipping__x-button, #waboba-region-no-shipping__ok-button",
      )
      .forEach((i) => {
        i.addEventListener("click", () => {
          newDiv.classList.remove("show");
        });
      });

    localStorage.setItem("waboba.hasShowRegionView", new Date().getTime());
  }

  function run() {
    const lastShowAt = localStorage.getItem("waboba.hasShowRegionView")
      ? parseInt(localStorage.getItem("waboba.hasShowRegionView"))
      : null;
    const shownDaysAgo = lastShowAt
      ? (new Date().getTime() - lastShowAt) / 1000 / 3600
      : 0;

    if (shownDaysAgo > 0 && shownDaysAgo <= 7) return;

    const prevCountry = localStorage.getItem("waboba.country");
    if (prevCountry) return;

    fetch(apiEndpoint)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          const country = data.country_code;
          if (country) {
            localStorage.setItem("waboba.country", country);

            if (EU_COUNTRIE_CODES.includes(country)) {
              // Redirect to eu.waboba.com
              window.location.href = "https://eu.waboba.com";
            } else if (country !== "US") {
              showShipUSOnlyInfo();
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  run();

  console.log("Hello Waboba.");
})();
